import React, { useEffect, useRef, MouseEvent } from "react";
import { AnimatePresence } from "motion/react";
import { X } from "lucide-react";
import * as motion from "motion/react-client";

interface SettingsDialogProps {
    open: boolean;
    onClose: (open: boolean) => void;
    childRef?: React.ReactNode;
}

function SettingsDialog({ open, onClose, childRef }: SettingsDialogProps) {
    const dialogRef = useRef<HTMLDialogElement | null>(null);

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        if (open) {
            if (!dialog.open) dialog.showModal();
        } else {
            if (dialog.open) dialog.close();
        }
    }, [open]);

    // Used to stop propagation so inside clicks don't close dialog
    const stop = (e: MouseEvent) => e.stopPropagation();
    const closeDialog = () => onClose(false);

    return (
        <AnimatePresence>
            {open && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        onClick={closeDialog}
                    />

                    {/* Dialog */}
                    <motion.dialog
                        ref={dialogRef}
                        className="z-50 rounded-2xl p-6 shadow-xl w-[90%] max-w-md border-2 border-gray-200 backdrop-blur-lg"
                        style={{
                            // background: "linear-gradient(to bottom right, #1f2937, #1e3a8a)",
                            // background: "linear-gradient(to bottom right, #1f293780, #1e3a8a80)",
                            background: "linear-gradient(to bottom right, rgba(31, 41, 55, 0.5), rgba(30, 58, 138, 0.5))",
                            // background: "transparent",
                            color: "white" }}
                        onClick={() => onClose} // clicking outside content closes it
                        initial={{opacity: 0, scale: 0.85}}
                        animate={{opacity: 1, scale: 1}}
                        exit={{opacity: 0, scale: 0.85}}
                    >
                        <button
                            onClick={closeDialog}
                            className="text-xl absolute p-3 right-0 top-0"
                        >
                            <X />
                        </button>
                        {childRef}
                    </motion.dialog>
                </>
            )}
        </AnimatePresence>
    );
}

export default SettingsDialog;